import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  DEFECT_ACCEPTED,
  DEFECT_ACCEPTED_OUT_DATE,
  DEFECTED,
  DEFECTED_OUT_DATE,
  DISCUSS_APPROVED,
  DISCUSS_APPROVED_OUT_DATE,
  DISCUSS_FINISHED,
  DISCUSS_FINISHED_ACCEPTED,
  DISCUSS_FINISHED_ACCEPTED_OUT_DATE,
  DISCUSS_FINISHED_ACCEPTED_WITH_LEGAL_GROUND,
  DISCUSS_FINISHED_OUT_DATE,
  DISCUSS_FINISHED_REJECTED,
  DISCUSS_FINISHED_REJECTED_OUT_DATE,
  DISCUSS_FINISHED_REJECTED_WITH_LEGAL_GROUND,
  DISCUSS_REJECTED,
  DISCUSS_REJECTED_AND_WITH_LEGAL_GROUND,
  DISCUSS_REJECTED_OUT_DATE,
  NEW,
  NEW_OUT_DATE,
  VIOLATED,
  VIOLATED_PUBLISHED,
  VOTE_COMPLETED,
  VOTE_COMPLETED_OUT_DATE,
  VOTE_IN_PROGRESS,
  VOTE_IN_PROGRESS_OUT_DATE,
  VOTE_INCOMPLETE
} from './constants';
import { Municipality } from '../Municipality';
import { MunicipalityService } from '../municipality.service';
import { Response } from '../../shared/admin-models/classes/response.class';
import { Petition } from '../../shared/admin-models/interfaces/petition.interface';
import { PetitionHistory } from '../../shared/admin-models/interfaces/petition-history.interface';
import { PetitionSigners } from '../../shared/admin-models/interfaces/petitions-signers.interface';
import { Decision } from '../../shared/admin-models/interfaces/decision.interface';
import { Task } from '../../shared/admin-models/interfaces/task.interface';
import { TaskFeedback } from '../../shared/admin-models/interfaces/task-feedback.interface';
import { DraftPetition } from '../../shared/admin-models/interfaces/draft-Petition.iterface';
import { Reason } from '../../shared/admin-models/interfaces/reason.interface';
import { Feedback } from '../../shared/admin-models/interfaces/feedback.interface';
import { ExecutorAction } from '../../shared/admin-models/interfaces/executor-action.interface';
import { Status } from '../../shared/admin-models/interfaces/status.interface';
import { PetitionCategory } from '../../shared/admin-models/interfaces/petition-category.interface';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';
import { PetitionsAmount } from '../../shared/admin-models/interfaces/petitions-amount.interface';
import { environment } from '../../../environments/environment';

interface IdeaFilters {
  id?: number;
  authorFullName?: string;
  title?: string;
  categoryId?: number;
  statusIds?: number[];
}

@Injectable()
export class AdminService {
  private municipality: Municipality;

  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    private _municipalityService: MunicipalityService
  ) {
    this._municipalityService.currentMunicipality.subscribe(
      (data) => (this.municipality = data)
    );
  }

  get isMayor(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const mayorPermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.MAYOR.READ');
    return !!mayorPermission;
  }
  get IsExecute(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const EexecutePermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.EXECUTE.READ');
    return !!EexecutePermission;
  }
  get isPerform(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const performPermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.PERFORM.READ');
    return !!performPermission;
  }
  get isSupervise(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const supervisePermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.SUPERVISE.READ');
    return !!supervisePermission;
  }
  get isReview(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const reviewPermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.REVIEW.READ');
    return !!reviewPermission;
  }
  get isConfigurationsAdmin(): boolean {
    const sessionData = JSON.parse(localStorage.getItem('sessionData'));
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId] ||
      !sessionData.clients[this.municipality.clientId].permissions
    )
      return false;
    const mayorPermission = sessionData.clients[
      this.municipality.clientId
    ].permissions.find((permission) => permission === 'PT.CONFIG.ADD');
    return !!mayorPermission;
  }
  getIdeas(
    filters: IdeaFilters,
    paging = { page: 0, size: 10 }
  ): Observable<Response<Petition[]>> {
    const reqData = {
      data: {
        ...filters
      }
    };
    return this._httpClient.post<Response<Petition[]>>(
      `/api/ideas?page=${paging.page}&size=${paging.size}`,
      reqData
    );
  }
  getIdeaById(id: number): Observable<Petition> {
    return this._httpClient
      .get<Response<Petition>>(`/api/member/auth/idea/${id}`)
      .pipe(map((res: Response<Petition>) => res.result.data));
  }
  getPetitionHistory(ideaId: number): Observable<PetitionHistory[]> {
    return this._httpClient
      .get<Response<PetitionHistory[]>>(`/api/idea/${ideaId}/history`)
      .pipe(map((res: Response<PetitionHistory[]>) => res.result.data));
  }
  getIdeaSigners(
    ideaId: number,
    paging: { page: number; size: number }
  ): Observable<Response<PetitionSigners[]>> {
    const data = { petitionId: ideaId };
    return this._httpClient.post<Response<PetitionSigners[]>>(
      `/api/idea/signers?page=${paging.page}&size=${paging.size}`,
      { data }
    );
  }
  findCategories(paging?: {
    page: number;
    size: number;
  }): Observable<Response<PetitionCategory[]>> {
    const url = paging
      ? `/api/idea/categories?page=${paging.page}&size=${paging.size}`
      : '/api/idea/categories';
    return this._httpClient.post<Response<PetitionCategory[]>>(url, {
      data: {}
    });
  }
  findAdminCategories(paging?: {
    page: number;
    size: number;
  }): Observable<Response<PetitionCategory[]>> {
    const url = paging
      ? `/api/idea/categories/member?page=${paging.page}&size=${paging.size}`
      : '/api/idea/categories/member';
    return this._httpClient.post<Response<PetitionCategory[]>>(url, {
      data: {}
    });
  }
  getCategory(id: string): Observable<PetitionCategory> {
    return this._httpClient
      .get<Response<PetitionCategory>>(`/api/idea/category/${id}`)
      .pipe(map((res: Response<PetitionCategory>) => res.result.data));
  }
  addCategory(data: PetitionCategory): Observable<PetitionCategory> {
    return this._httpClient
      .post<Response<PetitionCategory>>('/api/idea/category', { data })
      .pipe(map((res: Response<PetitionCategory>) => res.result.data));
  }
  editCategory(data: PetitionCategory) {
    return this._httpClient
      .put<Response<PetitionCategory>>(`/api/idea/category/${data.id}`, { data })
      .pipe(map((res: Response<PetitionCategory>) => res.result.data));
  }
  deleteCategory(id: number): Observable<PetitionCategory> {
    return this._httpClient
      .delete<Response<PetitionCategory>>(`/api/idea/category/${id}`)
      .pipe(map((res: Response<PetitionCategory>) => res.result.data));
  }
  getDecision(ideaId: number): Observable<Decision[]> {
    const data = {
      petitionId: ideaId
    };
    return this._httpClient
      .post<Response<Decision[]>>('/api/idea/decisions', { data })
      .pipe(map((res: Response<Decision[]>) => res.result.data));
  }

  _hasAccessToAdminPanel(sessionData): boolean {
    if (
      !sessionData ||
      !sessionData.clients ||
      !sessionData.clients[this.municipality.clientId]
    )
      return false;
    const applications =
      sessionData.clients[this.municipality.clientId].applications;
    return !!applications['PT'];
  }
  get ssoUrl(): string {
    return environment.ssoUrl;
  }
  redirectToForbiddenIfNoPermission(
    isAdminRoute: boolean,
    sessionData: any
  ): void {
    if (isAdminRoute && !this._hasAccessToAdminPanel(sessionData)) {
      const isAdmin = this._router.url.includes('admin');
      const urlEndPoint = isAdmin ? 'private' : 'public';

      document.location.href = `${this.ssoUrl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
      //   this._router.navigate(['forbidden']);
    }
  }
  getTasks(ideaId: number): Observable<Task[]> {
    const data = {
      petitionId: ideaId
    };
    return this._httpClient
      .post<Response<Task[]>>('/api/idea/tasks', { data })
      .pipe(map((res: Response<Task[]>) => res.result.data));
  }
  getTaskFeedbacks(taskId: number): Observable<TaskFeedback[]> {
    return this._httpClient
      .get<Response<TaskFeedback[]>>(`/api/idea/task/${taskId}/feedback`)
      .pipe(map((res: Response<TaskFeedback[]>) => res.result.data));
  }
  addTaskFeedbacks(data: { petitionId: number; commentary: string }) {
    return this._httpClient
      .post(`/api/idea/task/feedback`, { data })
      .pipe(map((res: any) => res.result.data));
  }
  deleteTaskExecutor(petitionId: number, employeeId: number) {
    return this._httpClient.delete(
      `/api/idea/${petitionId}/executor/${employeeId}/task`
    );
  }
  getMajorEmployees() {
    const data = {
      onlyMajorRoles: true
    };
    return this._httpClient
      .post(`/api/idea/employees?page=0&size=10000`, { data })
      .pipe(map((res: any) => res.result.data));
  }

  sendPetitionForDiscuss(data) {
    return this._httpClient.put(
      `/api/idea/${data.petitionId}/status/discuss/approve`,
      { data }
    );
  }

  findStatusById(id: number) {
    const statuses = [
      NEW_OUT_DATE,
      NEW,
      VOTE_IN_PROGRESS,
      VOTE_IN_PROGRESS_OUT_DATE,
      VIOLATED,
      VIOLATED_PUBLISHED,
      VOTE_COMPLETED,
      VOTE_COMPLETED_OUT_DATE,
      VOTE_INCOMPLETE,
      DISCUSS_APPROVED,
      DISCUSS_APPROVED_OUT_DATE,
      DISCUSS_REJECTED,
      DISCUSS_REJECTED_OUT_DATE,
      DISCUSS_REJECTED_AND_WITH_LEGAL_GROUND,
      DEFECTED,
      DEFECTED_OUT_DATE,
      DEFECT_ACCEPTED,
      DEFECT_ACCEPTED_OUT_DATE,
      DISCUSS_FINISHED,
      DISCUSS_FINISHED_OUT_DATE,
      DISCUSS_FINISHED_ACCEPTED,
      DISCUSS_FINISHED_ACCEPTED_OUT_DATE,
      DISCUSS_FINISHED_ACCEPTED_WITH_LEGAL_GROUND,
      DISCUSS_FINISHED_REJECTED,
      DISCUSS_FINISHED_REJECTED_OUT_DATE,
      DISCUSS_FINISHED_REJECTED_WITH_LEGAL_GROUND
    ];
    return statuses.find((status) => status.id === id);
  }
  changeSupervisor(data) {
    return this._httpClient.put('/api/idea/task/supervisor', { data });
  }
  addTaskExecutor(data) {
    return this._httpClient.post('/api/idea/executor/task', { data });
  }
  employeeActionCheck(petitionId: number): Observable<ExecutorAction> {
    return this._httpClient
      .get<Response<ExecutorAction>>(
        `/api/idea/${petitionId}/task/employee/action/check`
      )
      .pipe(map((res: Response<ExecutorAction>) => res.result.data));
  }
  openFilePdf(fileId: string) {
    const url = new URL(`/idea/file/${fileId}`, environment.apiUlr).toString();
    window.open(url, '_blank');
  }
  getDefectedPetitions(petitionId: number) {
    return this._httpClient
      .get(`/api/member/idea/${petitionId}/defected`)
      .pipe(map((res: any) => res.result.data));
  }
  findDrafts(data): Observable<Response<DraftPetition[]>> {
    return this._httpClient.post<Response<DraftPetition[]>>('/api/idea/drafts', {
      data
    });
  }
  saveDratf(data: DraftPetition): Observable<DraftPetition> {
    return this._httpClient
      .post<Response<DraftPetition>>('/api/idea/draft', { data })
      .pipe(map((res: Response<DraftPetition>) => res.result.data));
  }
  uploadFile(file: FormData) {
    return this._httpClient
      .post('/api/fs/file', file)
      .pipe(map((res: Response<any>) => res.result.data));
  }
  changePetitionStatusToInVote(data, petitionId: number): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(`/api/idea/${petitionId}/status/invote`, { data })
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changePetitionStatusToDefect(data, petitionId: number): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(`/api/idea/${petitionId}/status/defect`, { data })
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changePetitionStatusToDiscussRejected(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/final/legal/reject`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changeStatusToDiscussRejectApproved(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/reject/approve`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changeStatusToDiscussFinalLegalReject(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/final/reject`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changePetitionStatusToDiscussFinalApproveLegan(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/final/legal/approve`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  chaneStatusToRejectBeforeDiscuss(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(`/api/idea/${petitionId}/status/discuss/reject`, {
        data
      })
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  chaneStatusToFinalReject(data, petitionId: number): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/final/reject`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changeStatusToPubliShBlocked(data, petitionId: number): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(`/api/idea/${petitionId}/status/violate/publish`, {
        data
      })
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changeStatusToBlocked(data, petitionId: number): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(`/api/idea/${petitionId}/status/violate`, { data })
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  changeStatusToFinalLegalApprove(
    data,
    petitionId: number
  ): Observable<Status> {
    return this._httpClient
      .put<Response<Status>>(
        `/api/idea/${petitionId}/status/discuss/final/approve`,
        { data }
      )
      .pipe(map((res: Response<Status>) => res.result.data));
  }
  getReasons(): Observable<Reason[]> {
    return this._httpClient
      .post<Response<Reason[]>>('/api/idea/reasons', { data: {} })
      .pipe(map((res: Response<Reason[]>) => res.result.data));
  }
  getMayorFeedbacks(data): Observable<Feedback[]> {
    return this._httpClient
      .post<Response<Feedback[]>>('/api/idea/feedbacks', { data })
      .pipe(map((res: Response<Feedback[]>) => res.result.data));
  }
  sendExecutorAnswer(data) {
    return this._httpClient
      .post('/api/idea/employee/answer', { data })
      .pipe(map((res: any) => res.result.data));
  }
  getConfigs(): Observable<PetitionAdminConfigs> {
    return this._httpClient
      .get<Response<PetitionAdminConfigs>>('/api/idea/config/get')
      .pipe(map((res: Response<PetitionAdminConfigs>) => res.result.data));
  }
  saveConfigs(data: PetitionAdminConfigs): Observable<PetitionAdminConfigs> {
    return this._httpClient
      .post<Response<PetitionAdminConfigs>>('/api/idea/config', { data })
      .pipe(map((res: Response<PetitionAdminConfigs>) => res.result.data));
  }
  getPetitionsAmountByStatuses(): Observable<PetitionsAmount[]> {
    return this._httpClient
      .get<Response<PetitionsAmount[]>>('/api/idea/amount/statuses')
      .pipe(map((res: Response<PetitionsAmount[]>) => res.result.data));
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/admin/admin.service.ts